import { initAllPreloadScriptsLoaded, initOnLoad, initOnReady } from "./utils";
import { store } from "./store";

/**
 *
 */
export class EventLoader {
  /**
 *
 */
  public readonly store = store;

  constructor() {
    initOnReady();
    initOnLoad();
    initAllPreloadScriptsLoaded();
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  onReady<F extends EventListener>(priority: number, fn: F): void {
    if (store.onReadyFired) return void fn(store.onReadyEvent as Event);
    store.onReadyQueue.push({ priority, fn });
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  onLoad<F extends EventListener>(priority: number, fn: F): void {
    if (store.onLoadFired) return void fn(store.onLoadEvent as Event);
    store.onLoadQueue.push({ priority, fn });
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  onAllPreloadScriptsLoaded<F extends EventListener>(priority: number, fn: F): void {
    if (store.allPreloadScriptsLoadedFired)
      return void fn(store.allPreloadScriptsLoadedEvent as Event);
    store.allPreloadScriptsLoadedQueue.push({ priority, fn });
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  onAllJavascriptLoaded<F extends EventListener>(priority: number, fn: F): void {
    if (store.allJavascriptLoadedComplete) return void fn({} as Event);
    store.allJavascriptLoadedQueue.push({ priority, fn });
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  onAllScriptsExecuted<F extends EventListener>(priority: number, fn: F): void {
    this.onAllPreloadScriptsLoaded(priority, fn);
  }
}

/**
 *
 *
 */
export function eventLoader(): EventLoader {
  return new EventLoader();
}
